module.exports = __webpack_public_path__ + "img/findtheletter.8cee4d76.png";